import React from 'react';
import ReactModal from 'react-modal';
import ErrorBoundary from './components/boundary';
import { Provider as StoreProvider } from './store/restash';
import Router from './routes';
import ApolloProvider from './providers/apollo';
import ToastProvider from './providers/toast';

ReactModal.setAppElement('#root');

const App = (): JSX.Element => (
  <ErrorBoundary>
    <StoreProvider>
      <ApolloProvider>
        <Router />
      </ApolloProvider>
      <ToastProvider />
    </StoreProvider>
  </ErrorBoundary>
);

export default App;
